<template>
  <div class="contractStatus-wrapper">
    <div class="top-img">
      <img v-show="status === '1'" src="@static/images/externalpage/contractStatus/1.png" />
      <img v-show="status !== '1'" src="@static/images/externalpage/contractStatus/2.png" />
    </div>
    <div class="middle-content">
      <!-- 签约状态异常 -->
      <div class="status-title">{{renderJSON[status].title}}</div>
      <div class="status-des">{{renderJSON[status].txt}}</div>
      <div v-if="renderJSON[status].input" class="status-input">
        <input :placeholder="renderJSON[status].input" v-model="verfyCode" />
        <div class="verfycodetips" v-show="verfyCodeShow">{{verfyCodeTip}}</div>
      </div>
      <div class="status-btn">
        <div
          v-for="(item,i) in renderJSON[status].btn"
          :key="i"
          :class="item.class"
          @click="item.fn"
        >{{item.txt}}</div>
      </div>
    </div>
    <div class="common-bottom">
      <div class="line">温馨提示</div>
      <div class="tips">如有疑问，请联系梧桐树保险经纪全国24小时服务热线400-9955-788</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      verfyCodeShow: false,
      verfyCodeTip: "请输入验证码！",
      status: "1", //1签约状态异常 2 验证码签约 3点击完成签约 4按照指引完成签约
      orderId: null, //订单ID
      rdSeq: null, //流水号
      verfyCode: "", //验证码
      renderJSON: {
        "1": {
          img: "1.png",
          title: "签约状态异常",
          txt:
            "您选择的银行账户签约状态异常或正在签约中，请更换银行卡投保或完成签约。",
          input: null,
          btn: [
            {
              txt: "重新投保",
              class: "leftBtn",
              fn: this.reInsure
            },
            {
              txt: "在线客服",
              class: "rightBtn",
              fn: this.goQiDian
            }
          ]
        },
        "2": {
          img: "2.png",
          title: "账户未签约",
          txt:
            "您选择的银行账户未签约，请填写银行账户预留手机号收到的验证码完成签约。",
          input: "验证码",
          btn: [
            {
              txt: "立即签约",
              class: "oneBlue",
              fn: this.verfyCodefn
            }
          ]
        },
        "3": {
          img: "2.png",
          title: "账户未签约",
          txt: "您的银行账户未签约，请点击下方按钮完成签约。",
          input: null,
          btn: [
            {
              txt: "立即签约",
              class: "oneBlue",
              fn: this.goContract
            }
          ]
        },
        "4": {
          img: "2.png",
          title: "账户未签约",
          txt:
            "您选择的银行账户未签约，请根据银行卡预留手机号短信指引完成签约。",
          input: null,
          btn: [
            {
              txt: "家庭保单管家",
              class: "leftBtn",
              fn: this.goMypolicylist
            },
            {
              txt: "在线客服",
              class: "rightBtn",
              fn: this.goQiDian
            }
          ]
        }
      }
    };
  },
  components: {},
  created() {},
  methods: {
    //重新投保
    reInsure() {
      console.log("重新投保");
      window.location.href =
        "https://bx.wts9999.net/m/market/pros-detail.html?id=1037579185469644801";
    },
    //在线客服
    goQiDian() {
      console.log("在线客服");
      window.location.href =
        "https://wtsbx.qiyukf.com/client?k=59ed88a4552beb1d89cb502bb4885dd6&wp=1&robotShuntSwitch=0&gid=484878140&language=zh-cn&templateId=6674361";
    },
    //验证码提交
    verfyCodefn() {
      if (this.verfyCode) {
        this.$http({
          url: "/bus/core/signConfirm/zy/" + this.orderId,
          data: {
            rdSeq: this.rdSeq,
            verfyCode: this.verfyCode
          }
        })
          .then(res => {
            if (res.data === "签约成功") {
              window.location.href =
                "/m/market/orderStatus.html?orderId=" + this.orderId;
            } else {
              this.$notice.alert(res.data);
            }
          })
          .catch(err => {});
      } else {
        this.verfyCodeShow = true;
        this.verfyCodeTip = "请输入验证码！";
      }
    },
    //立即签约
    goContract() {
      console.log("立即签约");
    },
    //家庭保单管家
    goMypolicylist() {
      console.log("家庭保单管家");
      //personal/policyMyList
      this.$router.push({
        path: "/personal/policyMyList"
      });
    }
  },
  mounted() {
    //获取地址栏上方的签约状态
    console.log(this.$route.query);
    this.status = this.$route.query.status || "1";
    this.orderId = this.$route.query.orderId || null;
    this.rdSeq = this.$route.query.rdSeq || null;
  }
};
</script>

<style lang="scss">
.contractStatus-wrapper {
  width: r(750);
  padding: r(0) r(42);
  .top-img {
    width: r(205);
    height: r(205);
    margin: 0 auto;
    margin-top: r(75);
    & > img {
      width: r(205);
      height: r(205);
    }
  }
  .middle-content {
    .status-title {
      font-size: r(34);
      text-align: center;
    }
    .status-des {
      font-size: r(28);
      text-align: center;
    }
    .status-input {
      width: r(666);
      margin-top: r(60);
      margin-bottom: r(-50);
      & > input {
        width: r(662);
        height: r(86);
        border: 1px solid #e5e5e5;
        text-indent: r(30);
        border-radius: r(10);
        font-size: r(32);
      }
      & > .verfycodetips {
        font-size: r(28);
        color: red;
        text-align: left;
        text-indent: r(30);
        line-height: r(40);
      }
    }
    .status-btn {
      font-size: r(32);
      text-align: center;
      overflow: hidden;
      margin: r(60) r(0);
      .oneBlue {
        width: r(666);
        height: r(90);
        line-height: r(90);
        background: #4580f6;
        border-radius: r(10);
        color: #fff;
      }
      .leftBtn {
        background: #fff;
        color: #4580f6;
        border: 1px solid #4580f6;
        border-radius: r(10);
        width: r(316);
        height: r(86);
        line-height: r(86);
        float: left;
      }
      .rightBtn {
        background: #4580f6;
        color: #fff;
        border-radius: r(10);
        width: r(316);
        height: r(86);
        line-height: r(86);
        float: right;
      }
    }
  }
  .common-bottom {
    font-size: r(30);
    width: r(666);
    color: #636363;
    .line {
      display: table;
      width: r(666);
      line-height: r(60);
      white-space: nowrap;
      border-spacing: r(20) r(0);
    }
    .line:before,
    .line:after {
      display: table-cell;
      content: "";
      width: 50%;
      // background:#e5e5e5;
      background: -webkit-linear-gradient(#e5e5e5, #e5e5e5) repeat-x left center;
      background: linear-gradient(#e5e5e5, #e5e5e5) repeat-x left center;
      background-size: 1px 1px;
    }
  }
}
</style>